import EditorMain from "../../../components/EditorMain";
import EditorFotoKendaraanSection from "../../../components/foto/EditorFotoKendaraanSection";
import editorConfig from "../utils/editorConfig";
import useEditorTrailerDialogs from "../hooks/header/useEditorTrailerDialogs";
import useEditorValidation from "../hooks/validation/useEditorValidation";
import EditorHeaderTopRows from "./header/EditorHeaderTopRows";
import EditorTrailerDialogs from "./dialogs/EditorTrailerDialogs";
import EditorTrailerCheckList from "./checklist/EditorTrailerCheckList";

// Everything that makes the mobil editor different from the trado editor.
// The page itself is the shared EditorMain (features/cek-keluar-masuk/components).
const mobilEditorVariant = {
  config: editorConfig,
  useTrailerDialogs: useEditorTrailerDialogs,
  useValidation: useEditorValidation,
  HeaderTopRows: EditorHeaderTopRows,
  TrailerDialogs: EditorTrailerDialogs,
  TrailerCheckList: EditorTrailerCheckList,
  FotoSections: EditorFotoKendaraanSection,

  // mobil: only the "keamanan" boxes validate before verifying
  buildSignatureValidators: (validation) => ({
    onValidateKeamananBerangkat: () =>
      validation.handleValidateKeamanan("berangkat"),
    onValidateKeamananKembali: () =>
      validation.handleValidateKeamanan("kembali"),
  }),
};

const CekKeluarMasukEditorMain = () => {
  return <EditorMain variant={mobilEditorVariant} />;
};

export default CekKeluarMasukEditorMain;
